$(document).ready(function() {
  // Increase quantity button
  $(document).on('click', '.increase-quantity-btn', function() {
    var $cartItem = $(this).closest('.cdk_cart_item');
    var keyId = $cartItem.attr('key-id');
    var groupId = $cartItem.attr('data-groupid');
    var $quantity = $cartItem.find('.item-quantity');
    var newQuantity = parseInt($quantity.val()) + 1;
    $('.cdk_cart_item[data-groupid="' + groupId + '"]').addClass('loading');
    $('.cdk_cart_item[data-groupid="' + groupId + '"]').find('.item-quantity').val(newQuantity);
    $cartItem.addClass('loading');
    updateQuantityByGroupId(groupId, newQuantity);
    $quantity.val(newQuantity);
  });

  // Decrease quantity button
  $(document).on('click', '.decrease-quantity-btn', function() {
    var $cartItem = $(this).closest('.cdk_cart_item');
    var keyId = $cartItem.attr('key-id');
    var groupId = $cartItem.attr('data-groupid');
    var $quantity = $cartItem.find('.item-quantity');
    var newQuantity = parseInt($quantity.val()) - 1;
    $('.cdk_cart_item[data-groupid="' + groupId + '"]').addClass('loading');
    $('.cdk_cart_item[data-groupid="' + groupId + '"]').find('.item-quantity').val(newQuantity);
    $cartItem.addClass('loading');

    if (newQuantity >= 0) {
      updateQuantityByGroupId(groupId, newQuantity);
      $quantity.val(newQuantity);
    }
    if (newQuantity == 0) {
      $cartItem.slideDown().remove();
    }
  });

   // Increase quantity button
  $(document).on('change', '.quantity-control .item-quantity', function() {
    var $cartItem = $(this).closest('.cdk_cart_item');
    var keyId = $cartItem.attr('key-id');
    var groupId = $cartItem.attr('data-groupid');
    var newQuantity = $(this).val();
    $('.cdk_cart_item[data-groupid="' + groupId + '"]').addClass('loading');
    $('.cdk_cart_item[data-groupid="' + groupId + '"]').find('.item-quantity').val(newQuantity);
    $cartItem.addClass('loading');
    updateQuantityByGroupId(groupId, newQuantity);
    $quantity.val(newQuantity);
  });

  // Remove item button
  $(document).on('click', '.cdk_remove', function() {
    var $cartItem = $(this).closest('.cdk_cart_item');
    var keyId = $cartItem.attr('key-id');
    var groupId = $cartItem.attr('data-groupid');
    var newQuantity = 0;

    updateQuantityByGroupId(groupId, newQuantity);
    $cartItem.slideDown().remove();
  });

  // Function to update cart item on Shopify
  function updateCartItem(keyId, newQuantity) {
    var groupId = $('.cdk_cart_item[key-id="' + keyId + '"]').attr('data-groupid');
    updateQuantityByGroupId(groupId, newQuantity);
  }

  // Function to update quantity by group id
  function updateQuantityByGroupId(groupId, newQuantity) {
    var data = {
      updates: {}
    };

    // Find all items with the same group id and update their quantities
    $('.cdk_cart_item[data-groupid="' + groupId + '"]').each(function() {
      var keyId = $(this).attr('key-id');
      data.updates[keyId] = newQuantity;
    });

    // Perform AJAX call to update quantities
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(cart) {
        // Handle success if needed
        updateCartItemCount();
      },
      error: function(xhr, status, error) {
        // Handle error if needed
      }
    });
  }

  // Function to format price
  function formatPrice(price) {
    var formattedPrice = (price / 100).toFixed(2); // Convert cents to dollars and fix to 2 decimal places
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD' // Change 'USD' to your desired currency code
    }).format(formattedPrice);
  }

   
  // Function to generate HTML for a cart item
  function generateCartItemHTML(item) {
    // Check if the item should be excluded
    
  
     // Check if variant_title is not null
    var var_additionalStyle = '';
    if (item.variant_title == null) {
      var_additionalStyle = 'display: none;';
    }
    // Check if the original_line_price is different and greater than line_price
    var mainPriceHTML = '';
    if (item.price !== item.final_price && item.price > item.final_price) {
        mainPriceHTML = `<span class="main_price">${formatPrice(item.price)}</span>`;
    }
    // Create HTML for the item using the provided item object 
    var html = `
      <div class="cdk_cart_item" key-id="${item.key}" data-groupid="${item.properties.timestamp}">
        <div class="cdk_cart_inner">
          <div class="image_box">
            <a href="${item.url}"><img src="${item.image}" /></a>
          </div>
          <div class="content_box">
            <p class="cart_title"><a href="${item.url}">${item.product_title}</a></p>
            <p class="cart_variant" style="${var_additionalStyle}">${ item.variant_title }</p>
            <div class="quantity-control">
              <span class="decrease-quantity-btn">-</span>
              <input type="text" class="item-quantity" value="${item.quantity}" />
              <span class="increase-quantity-btn">+</span>
            </div>
            <p class="cart_price">${mainPriceHTML}<span class="price">${formatPrice(item.final_price)}</span></p>
            <span class="cdk_remove"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve"> <defs> </defs> <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" > <path d="M 67.692 90 H 22.308 c -3.042 0 -5.518 -2.476 -5.518 -5.518 v -61 c 0 -1.104 0.896 -2 2 -2 h 52.42 c 1.104 0 2 0.896 2 2 v 61 C 73.21 87.524 70.734 90 67.692 90 z M 20.79 25.482 v 59 c 0 0.837 0.681 1.518 1.518 1.518 h 45.385 c 0.837 0 1.518 -0.681 1.518 -1.518 v -59 H 20.79 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" /> <path d="M 73.196 25.482 H 16.804 c -3.042 0 -5.518 -2.475 -5.518 -5.518 v -4.335 c 0 -3.042 2.475 -5.518 5.518 -5.518 h 56.393 c 3.042 0 5.518 2.475 5.518 5.518 v 4.335 C 78.714 23.007 76.238 25.482 73.196 25.482 z M 16.804 14.112 c -0.837 0 -1.518 0.681 -1.518 1.518 v 4.335 c 0 0.837 0.681 1.518 1.518 1.518 h 56.393 c 0.837 0 1.518 -0.681 1.518 -1.518 v -4.335 c 0 -0.837 -0.681 -1.518 -1.518 -1.518 H 16.804 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" /> <path d="M 57.197 14.112 H 32.803 c -1.104 0 -2 -0.896 -2 -2 V 5.518 C 30.803 2.476 33.278 0 36.321 0 h 17.358 c 3.043 0 5.519 2.476 5.519 5.518 v 6.594 C 59.197 13.216 58.302 14.112 57.197 14.112 z M 34.803 10.112 h 20.395 V 5.518 C 55.197 4.681 54.516 4 53.679 4 H 36.321 c -0.837 0 -1.518 0.681 -1.518 1.518 V 10.112 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" /> <path d="M 45 78.624 c -1.104 0 -2 -0.896 -2 -2 V 34.856 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 41.768 C 47 77.729 46.104 78.624 45 78.624 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" /> <path d="M 58.222 78.624 c -1.104 0 -2 -0.896 -2 -2 V 34.856 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 41.768 C 60.222 77.729 59.326 78.624 58.222 78.624 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" /> <path d="M 31.779 78.624 c -1.104 0 -2 -0.896 -2 -2 V 34.856 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 41.768 C 33.779 77.729 32.883 78.624 31.779 78.624 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" /> </g> </svg></span>
          </div>
        </div>
      </div>`;
    return html;
  }



  // Function to update cart item count and other details
  function updateCartItemCount() {
    var keysInUI = $('.cdk_cart_item').map(function() {
      return $(this).attr('key-id');
    }).get();

    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cartData) {
        var itemCount = cartData.item_count;
        var cartSubTotal = cartData.original_total_price;
        var cartDisocunt = cartData.total_discount;
        var cartTotal = cartData.total_price;
        var cartLength = cartData.items.length;
        // var itemCountFake = 0; // Initialize the item count to zero

      // Filter out items with specific product IDs
      var filteredItems = cartData.items.filter(function (item) {
        return item.product_id !== 8170890133733 && item.product_id !== 8390838124773  && item.product_id !== 8170890395877;
      });

      // Calculate the total item count excluding specific products
      // for (var i = 0; i < filteredItems.length; i++) {
      //   itemCountFake += filteredItems[i].quantity;
      // }
        // Get the number of items in the cart
        var numberOfItems = $('.cdk_cart_item').length;
        console.log("Number of items in the cart:", numberOfItems);

        if (cartLength != numberOfItems) {
          $('.cdk_cart_items_main').empty(); // Clear existing cart items

          for (var i = 0; i < cartData.items.length; i++) {
            var newItemHTML = generateCartItemHTML(cartData.items[i], cartData.items[i].properties);
            $('.cdk_cart_items_main').prepend(newItemHTML);
          }
        }
        $('.cart-link__bubble-num').text(itemCount);

        if (cartSubTotal != cartTotal) {
          $('.cdk_cart_subtotal').text(formatPrice(cartSubTotal));
          $('.cdk_cart_footer .cdk_cart_footer_item.cart_sub_total').show();
        } else {
          $('.cdk_cart_subtotal').text(formatPrice(cartSubTotal));
          $('.cdk_cart_footer .cdk_cart_footer_item.cart_sub_total').hide();
        }

        if (cartDisocunt != '0') {
          $('.cdk_cart_disocunt').text('-' + formatPrice(cartDisocunt));
          $('.cdk_cart_footer .cdk_cart_footer_item.cart_discount').show();
        } else {
          $('.cdk_cart_disocunt').text('-' + formatPrice(cartDisocunt));
          $('.cdk_cart_footer .cdk_cart_footer_item.cart_discount').hide();
        }

        if (cartTotal != '0') {
          $('.cdk_cart_total').text(formatPrice(cartTotal));
          $('[data-subtotal-pay]').text(formatPrice(cartTotal / 4));
          $('.cdk_cart_footer .cdk_cart_footer_item.cart_total').show();
        } else {
          $('.cdk_cart_total').text(formatPrice(cartTotal));
          $('.cdk_cart_footer .cdk_cart_footer_item').hide();
          $('.cdk-cart-container').addClass('is-empty');
        }

        $('.cdk_cart_item').removeClass('loading');

      },
      error: function(XMLHttpRequest, textStatus, errorThrown) {
        console.error('Error fetching cart data:', textStatus, errorThrown);
      }
    });
  } 
 
});


$(document).ready(function(){
  $(".mobile-logo-close .header__toggle__icon").click(function(){
    $(this).toggleClass("open");
    $(".mobile-toggle-menu").slideToggle("milliseconds");
  });

  $('.product-single__variants').change(function () {
    var thisvarid = $('.product-single__variants').val();
    //console.log('thisvarid::'+thisvarid);
    var thisPreorder = $(this).find('option[value="'+thisvarid+'"]').attr('data-preorder');
    var percentage = $(this).find('option[value="'+thisvarid+'"]').attr('var-off-percent');
    var amountOff = $(this).find('option[value="'+thisvarid+'"]').attr('var-off-amount');
    var varAbalibility = $(this).find('option[value="'+thisvarid+'"]').attr('var-availability');
     // var thisDiamond = $(this).find('option[value="'+thisvarid+'"]').attr('data-diamond');
    // console.log('percentage::'+percentage);
    // console.log('availibility::'+varAbalibility);
    console.log('amountOff::'+amountOff);

    if(varAbalibility == 'true'){
      $('.product-block.engraving_block').removeClass('var_soldout');
    }else{
      $('.product-block.engraving_block').addClass('var_soldout');
    }

    if(thisPreorder == 'true'){
      $('#preorder_input_hidden').html('<input type="hidden" name="properties[Order Type]" value="Pre Order">');
      $('.cdk_preorder_text').text('פריט זה יסופק תוך 20 עד 40 ימי עסקים.').addClass('active_po').show();
      $('[data-add-to-cart-text]').text('הזמנה מוקדמת');
      $('[data-add-to-cart-text]').closest('.add-to-cart').addClass('cdk_preorder_btn');
    }else{
      $('[data-add-to-cart-text]').closest('.add-to-cart').removeClass('cdk_preorder_btn');
      $('#preorder_input_hidden').html('');
      $('.cdk_preorder_text').hide().removeClass('active_po');  
      //  if(thisDiamond == 'true'){
      //   $('.cdk_preorder_text').text('This item is made to order and delivered within 15-20 days.').addClass('active_po').show();
      // }else{
      //   $('.cdk_preorder_text').hide().removeClass('active_po');  
      // } 
      
    }
    // console.log('percentage::'+percentage);
    if(percentage){
      $('[cdk-price-off-amount]').text(percentage);
      $('.cdk_product_page__tag.cdk_product__tag__sale.saleTag_percent').show();
    }else{
      $('.cdk_product_page__tag.cdk_product__tag__sale.saleTag_percent').hide();
    }
    // console.log('percentage::'+percentage);
    if(amountOff){
      $('[cdk-price-off-currency]').text(amountOff);
      $('.cdk_product_page__tag.cdk_product__tag__sale.saleTag_dollar').show();
    }else{
      $('.cdk_product_page__tag.cdk_product__tag__sale.saleTag_dollar').hide();
    }
    
  })

})